import '../assets/cssFiles/commonComponents.css';

import React from 'react';

export const Popup = (props) => {
    if(!props.isShow){
        return null;
    }

    function handleClickMask(e){
        if(e.nativeEvent.target === document.getElementsByClassName("popup")[0]){
            props.clickMask();
        }else{
            return
        }
    }

    return(
        <div className="popup" onClick={(e)=>{handleClickMask(e)}}>
            {props.children}
        </div>
    )
}

export default Popup